/* Calls a supplied initialisation function once the DOM has been loaded */
export function afterDomLoaded(fn:()=>void)
{
    if ('attachEvent' in document ? document.readyState === "complete" : document.readyState !== "loading")
        fn();
    else
        document.addEventListener('DOMContentLoaded', fn);
}

